export { Label } from "#label";
